import { useEffect, useState } from 'react';
import Gallery from './Gallery';
import MapView from './MapView';
import './App.css';

function getCurrentRoute() {
  return {
    pathname: window.location.pathname,
    search: window.location.search,
  };
}

function App() {
  const [route, setRoute] = useState(getCurrentRoute);

  useEffect(() => {
    const handlePopState = () => setRoute(getCurrentRoute());
    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigate = (to) => {
    window.history.pushState({}, '', to);
    setRoute(getCurrentRoute());
  };

  const isMap = route.pathname === '/map';

  return (
    <div className="App">
      {isMap ? (
        <MapView navigate={navigate} search={route.search} pathname={route.pathname} />
      ) : (
        <Gallery navigate={navigate} pathname={route.pathname} />
      )}
    </div>
  );
}

export default App;
